import _ from 'lodash'
import { Injectable } from '@angular/core'

@Injectable({
    providedIn: 'root',
})
export class ApplicationVersionService {

    /**
     * Returns true, if given frontendVersion is higher or same as given backendVersion.
     * @param {String} frontendVersion
     * @param {String} backendVersion
     * @returns {Boolean}
     */
    isFrontendVersionActual(frontendVersion, backendVersion): boolean {
        let result = true

        if (_.isString(backendVersion) && _.isString(frontendVersion)) {
            let backendVersionArray = _.split(backendVersion.replace(/v/g, ''), '.')
            let frontendVersionArray = _.split(frontendVersion.replace(/v/g, ''), '.')

            if (_.isArray(backendVersionArray) && _.isArray(frontendVersionArray)) {
                // if some array is smaller than the other, fill smaller array with zeros
                const max = Math.max(backendVersionArray.length, frontendVersionArray.length)
                backendVersionArray = _.concat(backendVersionArray, Array(max - backendVersionArray.length).fill(0))
                frontendVersionArray = _.concat(frontendVersionArray, Array(max - frontendVersionArray.length).fill(0))

                for (let i = 0; i < backendVersionArray.length; i++) {
                    if (!_.isNaN(Number(backendVersionArray[i]))
                        && !_.isNaN(Number(frontendVersionArray[i]))
                    ) {
                        if (Number(backendVersionArray[i]) > Number(frontendVersionArray[i])) {
                            return false
                        } else if (Number(backendVersionArray[i]) < Number(frontendVersionArray[i])) {
                            break
                        }
                    } else {
                        break
                    }
                }
            }
        }

        return result
    }
}
